<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					 <el-input v-model="filters.title" placeholder="标题"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getArticle">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="articles" border stripe highlight-current-row v-loading="listLoading" @selection-change="selsChange" @sort-change="sortChange" style="width: 100%;"
		:header-row-style="{backgroundColor:'#eef1f6',lineHeight:'20px',color:'#000'}" :row-style="{height:'30px'}">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column type="index" label="编号"  width="80">
			</el-table-column>
			<el-table-column prop="title" label="标题" width="250">
			</el-table-column>
			<el-table-column label="文章url" min-width="160">
				<template slot-scope="scope">
					<a :href="articleUrl+'?article_id='+scope.row.id" target="_black">{{articleUrl+"?article_id="+scope.row.id}}</a>									
				</template>
			</el-table-column>
			<el-table-column  prop="click" label="点击跳转详情" width="150" >
		      <template slot-scope="scope" >	
			       {{ scope.row.click==1?'是':'否' }}										
			   </template>
			</el-table-column>
			<el-table-column label="操作" min-width="160">
				<template slot-scope="scope">
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
					<el-button type="info" size="small" @click="handleBrowse(scope.$index, scope.row)">预览</el-button>
					
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-col :span="8"> <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button></el-col>
			<el-col :span="8">
				<el-pagination @size-change="handleSizeChange"  @current-change="handleCurrentChange" :current-page="currentPage"
							:page-sizes="[10, 20, 30, 40,50]" :page-size="pageSize"  layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:left;">
				</el-pagination>
			</el-col>
		</el-col>
	</section>
</template>

<script>
	//import util from '../../common/js/util'

	import { getArticleListPage,removeArticle,batchremoveArticle,articleUrl } from '../../api/api';
   
   

 let CurrentUserID="",Session=""; 
	export default {

		data() {
			return {
			
				filters: {
					title: ''
				},
				
				articles: [],
				articleUrl:articleUrl,				
				total: 0,
				pageSize:10,
				currentPage: 1,
				listLoading: false,
				sels: [],//列表选中列
                 prop:"", 
				 order:""

			}
		},
		methods: {
			 handleSizeChange(val) {
				this.pageSize=val;                 
				this.getArticle();
             },		
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getArticle();
			
			},
			//获取列表
			getArticle() {
				let para = {
				    CurrentUserID:CurrentUserID,
					currentPage: this.currentPage,
					pageSize:this.pageSize,
					title:this.filters.title,					
					sortName:this.prop,
					sortOrder:this.order,
					Session:Session
				};
				this.listLoading = true;
				

            this.$http.jsonp(getArticleListPage, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							 this.total = res.data.articlelist.total;
					         this.articles = res.data.articlelist.articles;
					         this.listLoading = false;
                           
                         }
                         else{   
							  this.listLoading = false;
                              if (res.data.result_code==911)
							  {

                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
								this.$message({
									message:'接口错误',
									type: 'error'
								});

							  }

                             
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'访问接口失败',
                                type: 'error'
                              });
                       this.listLoading = false;
                   }
           )
			},

			handleAdd:function()
			{
               this.$router.push({path: '/articleedit',query: {status:0}});
			},

			//显示编辑界面
			handleEdit: function (index, row) {
				

				this.$router.push({path: '/articleedit',query:{status:1,id:row["id"]}});
								
			},

			handleBrowse:function(index,row)
			{
				
                window.open(articleUrl+"?article_id="+row.id,"_blank");
			},
			//删除
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { CurrentUserID:CurrentUserID,id: row.id,Session:Session};


                   this.$http.jsonp(removeArticle, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '删除成功',
							type: 'success'
						    });
							this.getArticle();
                           
                         }
                         else{  

							 this.listLoading = false;
							 if (res.data.result_code==911)
							  {
                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有权限删除',
                                type: 'error'
                              });
							}

                            
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'访问接口失败',
                                type: 'error'
                              });
                     this.listLoading = false;
                   });


				}
				
				).catch(() => {

				});
			},
			
		
			selsChange: function (sels) {
				this.sels = sels;
			},
			sortChange:function(order){
                   this.prop=order.prop;
				   this.order=order.order,
                 this.getArticle();
			},
			//批量删除
			batchRemove: function () {
				var ids = this.sels.map(item => item.id).toString();
				this.$confirm('确认删除选中记录吗？', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { ids: ids,CurrentUserID:CurrentUserID,Session:Session };


                   this.$http.jsonp(batchremoveArticle, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '删除成功',
							type: 'success'
						    });
							this.getArticle();
                           
                         }
                         else{                           
                                this.listLoading = false;
							if (res.data.result_code==911)
							  {
                                  this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有删除权限',
                                type: 'error'
                              });
							   return;
							}
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   });


				}).catch(() => {

				});
			}
		},
		mounted() {
			CurrentUserID=sessionStorage.getItem('userID')==null?0:sessionStorage.getItem('userID'); 
            Session=sessionStorage.getItem('session')==null?0:sessionStorage.getItem('session'); 
			this.getArticle();


		}
	}

</script>

<style scoped>
  .el_input_width{
	 width:220px; 
  }
</style>


// WEBPACK FOOTER //
// articlelist.vue?65ce472d